<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <!-- .type -->
            <b-col lg="6">
              <b-form-group
                id="input-group-1"
                :label="$t('library.type')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="type"
                  vid="type"
                  rules="required"
                >
                  <b-form-input
                    id="input-1"
                    v-model="newItem.type"
                    type="text"
                    :placeholder="$t('library.type')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .size -->
            <b-col lg="6">
              <b-form-group
                id="input-group-2"
                :label="$t('library.file_storage')"
                label-for="input-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="size"
                  vid="size"
                  rules="required"
                >
                  <b-form-input
                    id="input-2"
                    v-model="newItem.size"
                    type="number"
                    placeholder="100 KB"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .downloadable -->
            <b-col lg="6">
              <div class="demo-inline-spacing">
                <!-- primary -->
                <b-card-text class="mb-0">
                  {{ $t("library.can_download") }}
                </b-card-text>
                <b-form-checkbox
                  value="1"
                  class="custom-control-primary"
                  name="downloadable"
                  v-model="newItem.downloadable"
                  switch
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="DownloadCloudIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="ShieldOffIcon" />
                  </span>
                </b-form-checkbox>
                <b-card-text class="mb-0">
                  {{ $t("library.active") }}
                </b-card-text>
                <b-form-checkbox
                  value="1"
                  class="custom-control-primary"
                  name="active"
                  v-model="newItem.active"
                  switch
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="CheckIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="XIcon" />
                  </span>
                </b-form-checkbox>
              </div>
            </b-col>
            <!-- .active -->
            <b-col lg="6"> </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()"  variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "@/Controllers/File_settingsController";
import config from "@/config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
export default {
  name: "File_settingsForm",
  props: ["newItem"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  data() {
    return {
      file: {},
      
    };
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
  },
};
</script>

